import { jsxs as u, jsx as i } from "react/jsx-runtime";
import { c as t } from "../../../clsx-OuTLNxxd.js";
const g = "_title_1tre1_29", f = "_subtitle_1tre1_92", e = {
  "title-container": "_title-container_1tre1_29",
  "color-inverted": "_color-inverted_1tre1_29",
  "is-primary": "_is-primary_1tre1_32",
  "is-secondary": "_is-secondary_1tre1_35",
  "is-tertiary": "_is-tertiary_1tre1_38",
  "is-success": "_is-success_1tre1_41",
  "is-error": "_is-error_1tre1_44",
  "is-eco-green": "_is-eco-green_1tre1_47",
  title: g,
  "is-1": "_is-1_1tre1_59",
  "is-impact": "_is-impact_1tre1_68",
  "is-2": "_is-2_1tre1_72",
  "is-3": "_is-3_1tre1_82",
  subtitle: f,
  "dialog-overlay-show": "_dialog-overlay-show_1tre1_1",
  "dialog-content-show": "_dialog-content-show_1tre1_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1tre1_1"
}, h = {
  default: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "color-inverted"
};
function x({
  color: _ = "default",
  children: o,
  level: s = 3,
  hasHeaderTag: c = !1,
  isImpact: a,
  subtitle: r,
  className: n = "",
  title: l,
  ...d
}) {
  const y = `h${s}`, m = `${c ? y : "p"}`, p = t(e.title, e[`is-${s}`], a && e["is-impact"], n);
  return /* @__PURE__ */ u("div", { className: t(e["title-container"], e[h[_]]), children: [
    /* @__PURE__ */ i(m, { className: p, ...d, title: l, children: o }),
    r && /* @__PURE__ */ i("p", { className: t(e.subtitle), children: r })
  ] });
}
export {
  x as Title
};
